import { useState } from "react";
import style from "./ProxySettings.module.scss";
import cn from "classnames";
import { Funds, Term, Grant } from "./components";
import { IUser } from "@interfaces/admin/user";

export function ProxySettings({
    term,
    funds,
    grant,
    userData,
    isOpen
}: { 
    term?: boolean, 
    funds?: boolean,
    grant?: boolean,
    userData?: IUser,
    isOpen: boolean
}) {
    const [activeTab, setActiveTab] = useState<"term" | "funds" | "grant">("term")

    return (
        <div className={style.container}>
            <div className={style.tabsNavigate}>
                {term && <button
                    className={cn(style.button, activeTab === "term" && style.button_active)}
                    onClick={() => setActiveTab("term")}>
                    Термін
                </button>}
                {funds && <button
                    className={cn(style.button, activeTab === "funds" && style.button_active)}
                    onClick={() => setActiveTab("funds")}>
                    Кошти
                </button>}
                {grant && <button
                    className={cn(style.button, activeTab === "grant" && style.button_active)}
                    onClick={() => setActiveTab("grant")}>
                    Видати модем
                </button>}
            </div>
            {
                isOpen ?
                    <>
                        {
                            activeTab === "term"
                                ? <Term userData={userData} />
                                : null
                        }
                        {
                            activeTab === "funds"
                                ? <Funds userData={userData} />
                                : null
                        }
                        {
                            activeTab === "grant"
                                ? <Grant userData={userData} />
                                : null
                        }
                    </>
                    : null
            }
        </div>
    )
}